import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCategoryProductPerformance, getKeyMetrics, getQSDB, getSellerPerformance } from "helpers/backend_helper";
import "react-toastify/dist/ReactToastify.css";

export const getSellerPerformanceThunk = createAsyncThunk(
    "SellerPerformance/get",
    async ({startDate,endDate, keywordType, page, count,keyword,categoryId,brandId ,sortTypeProduct,sortTypeCart,sortTypeSold ,isProductVisitorFilter,isProductVisitorFilterCr, addToCartUnitsFilter,addToCartUnitsFilterCr, unitsSoldFilter,unitsSoldFilterCr}: {startDate:string, endDate:string, keywordType:string, page: number; count: number, keyword: string, categoryId: string, brandId: string ,sortTypeProduct:number,sortTypeCart:number,sortTypeSold:number,isProductVisitorFilter:boolean,isProductVisitorFilterCr:boolean, addToCartUnitsFilter:boolean,addToCartUnitsFilterCr:boolean, unitsSoldFilter:boolean , unitsSoldFilterCr:boolean,}) => {
  try {
    const response = await getSellerPerformance( startDate,endDate, keywordType, page, count,keyword, categoryId, brandId,sortTypeProduct,sortTypeCart,sortTypeSold,isProductVisitorFilter,isProductVisitorFilterCr, addToCartUnitsFilter,addToCartUnitsFilterCr, unitsSoldFilter,unitsSoldFilterCr );
    return response.data;
  } catch (error) {
    return error;
  }
})

export const getKeyMetricsThunk = createAsyncThunk(
    "KeyMatrics/get",
    async ({ startDate,endDate,isRevenue,isVisitor,isConversionRate,isRevenuePerBuyer,isPageView }: { startDate:string, endDate:string,isRevenue:boolean,isVisitor:boolean,isConversionRate:boolean,isRevenuePerBuyer:boolean,isPageView:boolean }) => {
  try {
    const response = await getKeyMetrics(startDate,endDate,isRevenue,isVisitor,isConversionRate,isRevenuePerBuyer,isPageView);
    return response.data;
  } catch (error) {
    return error;
  }
})

export const getCategoryProductPerformanceThunk = createAsyncThunk(
    "ProductPerformance/get",
    async ({ page, count,keyword, }: { page: number; count: number, keyword: string,}) => {
  try {
    const response = await getCategoryProductPerformance(  page, count,keyword,);
    return response.data;
  } catch (error) {
    return error;
  }
})

export const getQSDBThunk = createAsyncThunk(
    "qsdb/get",
    async ({ seller_id,start_date,end_date,types }: { seller_id:string,start_date:string,end_date:string,types: string[]; }) => {
  try {
    const response = await getQSDB(seller_id,start_date,end_date,types);
    return response;
  } catch (error) {
    return error;
  }
})